// @flow

import { restRoute } from 'server2';

import Api from './api';


export default class RestApi extends Api {
	static get API_VERSION (): string {
		return restRoute.version;
	}

	static get API_PREFIX (): string {
		return restRoute.prefix;
	}

	_normalize (urlParts: string[]): string[] {
		return [
			RestApi.API_PREFIX,
			RestApi.API_VERSION,
			...urlParts,
		];
	}
}

